import OtpInput from 'react-otp-input';
import { OtpPropsType, OtpRef, UseOtp } from "./index";
// import Button from "@elements/redesign/Button/Button";
import Edit from "@svg/redesign/Edit";
import { useTranslations } from "next-intl";
import Button from '@elements/button';
import { forwardRef, useImperativeHandle } from 'react';
import Support from '@svg/redesign/Support';


const Otp = forwardRef<OtpRef, OtpPropsType>((props, ref) => {
    const {
        handleEdit,
        handleResend,
        seconds,
        timerFinished,
        otp,
        setOtp,
        handleVerify,
        formatTime,
        loading,
        isProcessing,
        contact,
    } = UseOtp(props)
    const t = useTranslations()
    useImperativeHandle(ref, () => ({
        getSeconds: () => seconds,
    }));


    const renderInput = (props: any) => (
        <input
            {...props}
            inputMode='numeric'
            pattern='[0-9]*'
            type="number"
            className=" xs:w-14 xs:h-14 h-12 w-12  border border-[#0000003B] xs:rounded-2xl rounded-xl text-center text-xl font-normal text-mui-text-secondary focus:text-mui-text-primary  focus:!border-mui-primary-main focus:outline-mui-primary-main focus:ring-2 focus:ring-[0px,8px,24px,0px,#008AF6] !appearance-none"
        />
    )
    return (
        <div className="w-full flex flex-col gap-3 items-center flex-1 ">
            <div className="w-full flex flex-col gap-3 max-w-[330px] flex-1">
                <div className="w-full flex flex-col gap-3 items-center">
                    <h3 className=" text-black text-lg font-bold leading-8 text-center">{t("client_phoneverify_enterotp")}</h3>
                    <p className=" text-mui-text-secondary text-center text-sm font-medium leading-5">{t("client_phoneverify_enterotpdesc")}</p>
                    <div className="w-full flex items-center justify-between">
                        <bdi className=" text-mui-text-primary font-normal" >{`${props.countryCode}${props.phoneNumber}`}</bdi>
                        <button className=" text-mui-primary-info text-[13px] flex items-center gap-1 font-medium" onClick={handleEdit}><span>{t("client_phoneverify_changenumber")}</span> <Edit /></button>
                    </div>
                </div>
                <div className="w-full mt-2" dir="ltr">
                    <OtpInput
                        value={otp}
                        onChange={setOtp}
                        numInputs={5}
                        renderInput={renderInput}
                        skipDefaultStyles
                        shouldAutoFocus
                        containerStyle="flex justify-center !gap-3"
                        inputType="number"
                    />
                </div>
                {contact ? <div className='w-full flex items-center justify-center mt-2 mb-1'>
                    <a
                        href={`tel:${contact}`}
                        className='w-max flex gap-2 items-center justify-center'
                    >
                        <Support />
                        <span className=' text-mui-secondary-main text-sm font-bold'>{t("client_contact_support")}</span>
                    </a>
                </div> : null}
            </div>
            <div className=" w-full flex flex-col gap-8">
                <div className="w-full">
                    {timerFinished ? (
                        <div className="flex flex-col items-center justify-center gap-2">
                            <div className="flex items-center justify-center gap-2">
                                <p className="text-xs">{t("client_phoneverify_didnotreceive").replace("@", "")}</p> <button className=" text-button-primary underline text-sm font-normal tracking-[0.4px]" onClick={() => handleResend('sms')}>{t("client_phoneverify_sendagain")}</button>
                            </div>
                            <button className=" text-button-primary underline text-sm font-normal tracking-[0.4px]" onClick={() => handleResend('whatsapp')}>{t("client_phoneverify_sendviawhatsapp")}</button>
                        </div>
                    ) : (
                        <p className=" text-xs ">{t("client_phoneverify_resendtimer").replace("@", `${formatTime(seconds)}`)}</p>
                    )
                    }
                </div>
                <Button
                    theme="blue"
                    className="!font-bold !h-12 rounded-full text-sm "
                    isDisabled={otp.length < 5 || loading || isProcessing}
                    onClick={handleVerify}
                    loading={loading}
                >
                    {t("client_buttons_continue")}
                </Button>
                {/* <Button disabled={otp.length < 5} theme="primary" label={t("client_buttons_continue")} size="small" className=" !font-bold !h-12" onClick={handleVerify} /> */}
            </div>
        </div>
    );
})

Otp.displayName = 'Otp';

export default Otp;